import './style.css';

const Turismo = ({ descricao, banner, link }) => {
    // Valida se o banner tem um nome de arquivo válido
    const bannerValido = banner && banner !== '' && !banner.endsWith('/');
    
    return (
      <div className="turismo-item">
        {bannerValido && <img src={banner} alt={descricao} className="d-block custom-img" />}
        <div className="turismo-caption">
          <h3>{descricao}</h3>
          { link && <a href={link} className="btn btn-primary">Saiba mais</a>}
        </div>
      </div>
    );
  };
  
  export default Turismo;